import { Icon } from '@octano/global-ui';
import { UncontrolledTooltip } from 'reactstrap';

interface Props {
  show: boolean;
  tooltipId: string;
}

export function InfoWithTooltip({ show, tooltipId }: Props) {
  if (!show) return null;

  return (
    <div
      id={`infoWithTooltip-${tooltipId}`}
      style={{ width: 'fit-content', height: 'fit-content' }}
    >
      <Icon name="information" size={14.71} />
      <UncontrolledTooltip
        placement="bottom"
        target={`infoWithTooltip-${tooltipId}`}
      ></UncontrolledTooltip>
    </div>
  );
}
